import { type IntlShape } from "react-intl";
import { Skeleton, TableCell, TableRow } from "@mui/material";
import { type ReactElement } from "react";

import { type ClosingStatus, type ClosingScanFailedReason } from "@/schemas";

export const getSkeletonTableRows = (rowCount: number, columnCount: number): ReactElement[] => {
	return Array.from({ length: rowCount }, (_, rowIndex) => (
		<TableRow key={`skeleton-row-${rowIndex}`}>
			{Array.from({ length: columnCount }, (_, colIndex) => (
				<TableCell key={`skeleton-cell-${rowIndex}-${colIndex}`}>
					<Skeleton variant="rectangular" width="100%" height={30} sx={{ borderRadius: 1 }} />
				</TableCell>
			))}
		</TableRow>
	));
};

export const getClosingStatus = (status: ClosingStatus, intl: IntlShape): string => {
	switch (status) {
		case "ClosingRequired":
			return intl.formatMessage({
				id: "Closing Required",
				defaultMessage: "Closing Required",
			});

		case "Closing":
			return intl.formatMessage({
				id: "Closing",
				defaultMessage: "Closing",
			});

		case "Closed":
			return intl.formatMessage({
				id: "Closed",
				defaultMessage: "Closed",
			});

		case "ClosedManually":
			return intl.formatMessage({
				id: "Closed Manually",
				defaultMessage: "Closed Manually",
			});

		case "ClosingFailed":
			return intl.formatMessage({
				id: "Closing Failed",
				defaultMessage: "Closing Failed",
			});

		case "ClosingRemoved":
			return intl.formatMessage({
				id: "Closing Removed",
				defaultMessage: "Closing Removed",
			});

		default:
			return intl.formatMessage({
				id: "Unknown",
				defaultMessage: "Unknown",
			});
	}
};

export const getClosingScanFailureReason = (reason: ClosingScanFailedReason, intl: IntlShape): string => {
	switch (reason) {
		case "NoMatches":
			return intl.formatMessage({
				id: "Barcode not found",
				defaultMessage: "Barcode not found",
			});
		case "MultipleMatches":
			return intl.formatMessage({
				id: "Multiple barcode matches",
				defaultMessage: "Multiple barcode matches",
			});
		case "NoProductionOptionsForMachine":
			return intl.formatMessage({
				id: "No production options",
				defaultMessage: "No production options",
			});
		case "InvalidDataForResponse":
			return intl.formatMessage({
				id: "Invalid data",
				defaultMessage: "Invalid data",
			});
		case "ClosingRemoved":
			return intl.formatMessage({
				id: "Closing removed",
				defaultMessage: "Closing removed",
			});
	}
};
